import React from 'react';

/**
 * The verbatim VDURA confidentiality terms, ported unchanged from the classic
 * license agreement component under src/utils — legal copy, not to be
 * reworded, shortened or "modernised". Only the Tailwind classes are
 * retokenised (bg-gray-800 → bg-surface-raised, text-white → text-ink). Split
 * out of LicenseScreen.tsx so the legal text stays in one identifiable module.
 */
export function LicenseTerms() {
  return (
    <div className="mb-6 rounded-md bg-surface-raised p-4 text-sm text-ink">
      <p className="mb-4">
        By clicking "I AGREE" below, you acknowledge that you have read, understood, and agree to be
        bound by the following terms and conditions. If you do not agree to these terms, you must
        exit this website immediately.
      </p>

      <h3 className="mb-2 text-lg font-bold">1. CONFIDENTIALITY AND PROPRIETARY INFORMATION</h3>
      <p className="mb-4">
        The contents of this website, including but not limited to the product configuration tool,
        software specifications, hardware configurations, performance metrics, pricing information,
        and bill of materials ("Confidential Information"), are the exclusive and proprietary
        property of VDURA Inc. This Confidential Information is being shared with you strictly under
        the terms of your existing Non-Disclosure Agreement ("NDA") with VDURA Inc.
      </p>

      <h3 className="mb-2 text-lg font-bold">2. USAGE RESTRICTIONS</h3>
      <p className="mb-2">You agree to:</p>
      <ul className="mb-4 list-disc space-y-1 pl-6">
        <li>Use the Confidential Information solely for the purpose of configuring, evaluating, and selling VDURA products within the scope of your VAR partnership</li>
        <li>Maintain the strict confidentiality of all information accessed through this tool</li>
        <li>Not disclose, distribute, reproduce, or share access to any Confidential Information with any third party not covered by the existing NDA</li>
        <li>Not reverse engineer, decompile, or attempt to discover the source code or underlying algorithms of the configuration tool</li>
        <li>Not use the Confidential Information to develop competing products or services</li>
      </ul>

      <h3 className="mb-2 text-lg font-bold">3. LIABILITY FOR UNAUTHORIZED DISCLOSURE</h3>
      <p className="mb-2">
        You expressly acknowledge that any unauthorized disclosure or use of the Confidential
        Information would cause immediate, substantial, and irreparable harm to VDURA Inc., the
        monetary value of which would be difficult to determine. In the event of unauthorized
        disclosure:
      </p>
      <ul className="mb-4 list-disc space-y-1 pl-6">
        <li>You shall be personally liable for all damages resulting from such disclosure</li>
        <li>VDURA Inc. reserves the right to pursue all available legal remedies, including but not limited to injunctive relief, monetary damages, and termination of the VAR partnership</li>
        <li>You agree that VDURA Inc. shall be entitled to recover all costs and expenses, including reasonable attorneys' fees, incurred in enforcing this agreement</li>
      </ul>

      <h3 className="mb-2 text-lg font-bold">4. USER ACTIVITY MONITORING</h3>
      <p className="mb-2">
        VDURA Inc. tracks and monitors all user activity within this tool, including but not limited
        to:
      </p>
      <ul className="mb-4 list-disc space-y-1 pl-6">
        <li>Login times and durations</li>
        <li>Pages accessed and configurations created</li>
        <li>Data viewed, downloaded, or exported</li>
        <li>IP addresses and device information</li>
      </ul>
      <p className="mb-4">
        This monitoring is conducted for security purposes, to protect VDURA's Confidential
        Information, and to ensure compliance with this agreement.
      </p>

      <h3 className="mb-2 text-lg font-bold">5. ACKNOWLEDGMENT</h3>
      <p className="mb-2">By clicking "I AGREE," you acknowledge that:</p>
      <ul className="mb-4 list-disc space-y-1 pl-6">
        <li>You have authority to bind yourself and/or your organization to these terms</li>
        <li>You understand the sensitive and proprietary nature of the information contained in this tool</li>
        <li>You accept personal liability for any damages resulting from unauthorized disclosure</li>
        <li>Your access and use of this tool will be monitored</li>
      </ul>
    </div>
  );
}
